import axios, { type AxiosResponse } from 'axios'
import { CountryISO } from 'commons/constants/countries'
import type { MoneyPotData } from 'commons/types/user'

export type CreateAISRequestParams = {
	slug: string
	amount: number
	iban: string
	recipientName: string
}

export type CreateAISRequestResponse = {
	request_id: string
}

export const moneyPotService = {
	getMoneyPotInfo: async (slug: string): Promise<MoneyPotData> => {
		return axios
			.get(`${process.env.REACT_APP_POTS_URL}collect/moneypotdata?slug=${slug}`)
			.then((res: AxiosResponse<MoneyPotData>) => {
				return res.data
			})
	},
	createAISRequest: async ({
		slug,
		amount,
		iban,
		recipientName
	}: CreateAISRequestParams): Promise<CreateAISRequestResponse> => {
		return axios
			.post(
				`${process.env.REACT_APP_GATEWAY_BASE_URL}aispis/public/moneypot/${slug}/create-one-time-payment-request`,
				{
					amount,
					currency: 'EUR',
					destinations: [{ accountNumber: iban, type: 'iban' }],
					executionDate: new Date().toISOString().split('T')[0],
					market: CountryISO.FR,
					paymentScheme: 'SEPA_INSTANT_CREDIT_TRANSFER',
					recipientName,
					sourceMessage: 'Rechargement via IBAN'
				}
			)
			.then((res: AxiosResponse<CreateAISRequestResponse>) => res.data)
	}
}
